import * as type from '../actions/types';

const initialState = {
    available: [],
    pagination: {
        current_page: 1,
        per_page: 15,
        total_entries: 0,
        total_pages: 0,
        offset: 0,
    },
    offset: 0,
    loading: false,
    error: null,
}

export default function allProjectsData(state = initialState, action) {
    switch (action.type) {
        case type.GET_ALL_PROJECTS_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_ALL_PROJECTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                available: action.data.projects,
                pagination: action.data.pagination || state.pagination,
                offset: 0,
                serviced_zipcodes: action.data.serviced_zipcodes,
                serviced_zipcodes_count: action.data.serviced_zipcodes_count,
                fair_use: action.data.fair_use,
            }
        case type.GET_ALL_PROJECTS_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}
